/* eslint-disable no-dupe-keys -- legacy locale objects keep last-value keys */
export const translations = {
  English: {
    welcome: 'Welcome back',
    signIn: 'Sign in to your account',
    email: 'Email Address',
    password: 'Password',
    rememberMe: 'Remember me',
    forgot: 'Forgot?',
    forgotPassword: 'Forgot Password?',
    signInButton: 'Sign in',
    signingIn: 'Signing in...',
    noAccount: "Don't have an account?",
    signUp: 'Sign up',
    // Register page translations
    createAccount: 'Create account',
    joinAffiliateProgram: 'Join our partner program',
    firstName: 'First Name',
    lastName: 'Last Name',
    fullName: 'Full Name',
    enterFullName: 'Enter your full name',
    enterEmail: 'Enter your email',
    confirmPassword: 'Confirm',
    country: 'Country',
    selectCountry: 'Please select a country',
    noCountriesAvailable: 'No countries available',
    loading: 'Loading...',
    searchCountries: 'Search countries...',
    noCountriesFound: 'No countries found',
    mobileNumber: 'Mobile Number',
    stateProvince: 'State',
    selectFromMap: 'Select from Map',
    city: 'City',
    agreeTo: 'I agree to the',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    creatingAccount: 'Creating account...',
    alreadyHaveAccount: 'Already have an account?',
    selectLocation: 'Select Location',
    searchLocation: 'Search for a location...',
    searchCitiesStates: 'Search cities, states...',
    noLocationsFoundFor: 'No locations found for',
    addAsCustomLocation: 'Add',
    useAsStateProvince: 'Use this as your state',
    popularLocations: 'Popular Locations',
    noPredefinedLocations: 'No predefined locations available for this country',
    manuallyTypeStateCity: 'You can manually type your state and city in the form',
    atLeast8Characters: 'At least 8 characters',
    containsLetter: 'Contains letter',
    containsNumber: 'Contains number',
    containsSpecialCharacter: 'Contains special character',
    // Forgot password translations
    resetPassword: 'Reset password',
    enterEmailForReset: 'Enter your email to receive reset instructions',
    pleaseEnterEmail: 'Please enter your email address',
    emailNotFound: 'Email not found',
    sending: 'Sending...',
    sendResetLink: 'Send reset link',
    checkYourEmail: 'Check your email',
    resetInstructionsSent: 'We\'ve sent password reset instructions to your email address.',
    tryAnotherEmail: 'Try another email',
    backToSignIn: 'Back to sign in',
    fillFields: 'Please fill in all fields',
    invalidCredentials: 'Invalid credentials',
    // Background box translations
    loginBonus: 'LOGIN BONUS',
    welcomeBonus: '$500 Welcome',
    newUsersOnly: 'New Users Only',
    secureAccess: 'SECURE ACCESS',
    ssl256: '256-bit SSL',
    bankLevelSecurity: 'Bank Level Security',
    aiIntegration: 'AI INTEGRATION',
    smartTrading: 'Smart Trading',
    predictiveAnalytics: 'Predictive Analytics',
    globalNetwork: 'GLOBAL NETWORK',
    countries150: '150+ Countries',
    support247: '24/5 Support',
    // New floating box translations
    highLevelChart: 'HIGH LEVEL CHART',
    realTimeData: 'Real-time Data',
    advancedAnalytics: 'Advanced Analytics',
    commission: 'COMMISSION',
    earnMore: 'Earn More',
    instantPayouts: 'Instant Payouts',
    levelSystem: 'LEVEL SYSTEM',
    bronzeLevel: 'Bronze Level',
    silverGoldLevel: 'Silver & Gold',
    rewards: 'REWARDS',
    exclusiveBonus: 'Exclusive Bonus',
    vipBenefits: 'VIP Benefits',
    visitWebsite: 'Visit Website',
    // Dashboard translations
    dashboard: 'Dashboard',
    welcomeBack: 'Welcome back',
    totalRevenue: 'Total Revenue',
    totalCommissions: 'Total Commissions',
    activeAffiliates: 'Active Partners',
    conversionRate: 'Conversion Rate',
    partnerLink: 'Partner Link',
    copyLink: 'Copy Link',
    copied: 'Copied!',
    autoUpgradePackage: 'Auto Upgrade Level',
    currentPackage: 'Current Package',
    nextPackage: 'Next Package',
    progress: 'Progress',
    recentActivity: 'Recent Activity',
    quickActions: 'Quick Actions',
    performanceMetrics: 'Performance Metrics',
    viewAll: 'View All',
    // Navigation
    affiliates: 'Partners',
    commissions: 'Commissions',
    reports: 'Reports',
    settings: 'Settings',
    logout: 'Logout',
    // Dynamic Menu Items
    marketing: 'Marketing',
    rewards: 'Rewards',
    support: 'Support',
    notifications: 'Notifications',
    // Sub-menu items
    affiliateList: 'Partner List',
    affiliateRequests: 'Partner Requests',
    commissionHistory: 'Commission History',
    commissionSettings: 'Commission Settings',
    salesReports: 'Sales Reports',
    performanceReports: 'Performance Reports',
    analytics: 'Analytics',
    campaigns: 'Campaigns',
    marketingMaterials: 'Marketing Materials',
    rewardsProgram: 'Rewards Program',
    rewardsHistory: 'Rewards History',
    supportTickets: 'Support Tickets',
    faq: 'FAQ',
    profile: 'Profile',
    security: 'Security',
    preferences: 'Preferences',
    // Common
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    add: 'Add',
    update: 'Update',
    status: 'Status',
    // Chat System translations
    chatSupport: 'Chat Support',
    aiAssistant: 'AI Assistant',
    quickQuestions: 'Quick Questions',
    typeQuestion: 'Type your question...',
    connectAgent: 'Connect to Live Agent',
    connecting: 'Connecting...',
    agentConnected: 'Agent Connected!',
    noAnswer: "I don't have a specific answer for that question. Let me connect you with one of our live agents who can help you better. They'll be with you shortly!",
    welcomeMessage: 'Hello! Welcome to IB Broker support. I\'m here to help you with any questions about our services. You can select from the quick questions below or type your own question.',
    date: 'Date',
    amount: 'Amount',
    actions: 'Actions',
    // More Dashboard translations
    balance: 'Balance',
    totalClients: 'Total Clients',
    activeClients: 'Active Clients',
    level: 'Level',
    progressToLevel: 'Progress to Level',
    partnerLink: 'Partner Link',
    copyLink: 'Copy Link',
    copied: 'Copied!',
    autoUpgradePackage: 'Auto Upgrade Level',
    currentPackage: 'Current Package',
    nextPackage: 'Next Package',
    recentActivity: 'Recent Activity',
    quickActions: 'Quick Actions',
    performanceMetrics: 'Performance Metrics',
    viewAll: 'View All',
    // More common translations
    welcome: 'Welcome',
    back: 'Back',
    here: 'Here',
    is: 'is',
    with: 'with',
    your: 'Your',
    business: 'Business',
    today: 'Today',
    account: 'Account',
    overview: 'Overview',
    // More specific translations
    totalProfit: 'Total Profit',
    thisMonth: 'this month',
    lifetimeEarnings: 'Lifetime earnings',
    systemManagesLevel: 'System manages your level automatically',
    progressToNext: 'Progress to Next',
    autoUpgradeSystem: 'Auto-upgrade system',
    current: 'Current',
    required: 'Required',
    remaining: 'Remaining',
    autoUpgradeWhenTarget: 'Auto-upgrade when target reached',
    // More translations
    latestTransactions: 'Latest transactions and events',
    commonTasks: 'Common tasks and shortcuts',
    viewClients: 'View Clients',
    analytics: 'Analytics',
    support: 'Support',
    thisMonthPerformance: 'This month\'s performance overview',
    conversionRate: 'Conversion Rate',
    avgCommission: 'Avg. Commission',
    activeDays: 'Active Days',
    responseTime: 'Response Time'
  },
  हिंदी: {
    welcome: 'वापसी पर स्वागत है',
    signIn: 'अपने खाते में साइन इन करें',
    email: 'ईमेल पता',
    password: 'पासवर्ड',
    rememberMe: 'मुझे याद रखें',
    forgot: 'भूल गए?',
    forgotPassword: 'पासवर्ड भूल गए?',
    signInButton: 'साइन इन करें',
    signingIn: 'साइन इन हो रहा है...',
    noAccount: 'खाता नहीं है?',
    signUp: 'साइन अप करें',
    // Register page translations
    createAccount: 'खाता बनाएं',
    joinAffiliateProgram: 'हमारे सहयोगी कार्यक्रम में शामिल हों',
    fullName: 'पूरा नाम',
    enterFullName: 'अपना पूरा नाम दर्ज करें',
    enterEmail: 'अपना ईमेल दर्ज करें',
    confirmPassword: 'पुष्टि करें',
    country: 'देश',
    selectCountry: 'कृपया एक देश चुनें',
    noCountriesAvailable: 'कोई देश उपलब्ध नहीं',
    loading: 'लोड हो रहा है...',
    searchCountries: 'देश खोजें...',
    noCountriesFound: 'कोई देश नहीं मिला',
    mobileNumber: 'मोबाइल नंबर',
    stateProvince: 'राज्य',
    selectFromMap: 'मानचित्र से चुनें',
    city: 'शहर',
    agreeTo: 'मैं सहमत हूं',
    termsOfService: 'सेवा की शर्तें',
    and: 'और',
    privacyPolicy: 'गोपनीयता नीति',
    creatingAccount: 'खाता बनाया जा रहा है...',
    alreadyHaveAccount: 'पहले से खाता है?',
    selectLocation: 'स्थान चुनें',
    searchLocation: 'स्थान खोजें...',
    searchCitiesStates: 'शहर, राज्य खोजें...',
    noLocationsFoundFor: 'के लिए कोई स्थान नहीं मिला',
    addAsCustomLocation: 'जोड़ें',
    useAsStateProvince: 'इसे अपने राज्य के रूप में उपयोग करें',
    popularLocations: 'लोकप्रिय स्थान',
    noPredefinedLocations: 'इस देश के लिए कोई पूर्वनिर्धारित स्थान उपलब्ध नहीं',
    manuallyTypeStateCity: 'आप फॉर्म में अपना राज्य और शहर मैन्युअल रूप से टाइप कर सकते हैं',
    atLeast8Characters: 'कम से कम 8 अक्षर',
    containsLetter: 'अक्षर शामिल है',
    containsNumber: 'संख्या शामिल है',
    containsSpecialCharacter: 'विशेष वर्ण शामिल है',
    // Forgot password translations
    resetPassword: 'पासवर्ड रीसेट करें',
    enterEmailForReset: 'रीसेट निर्देश प्राप्त करने के लिए अपना ईमेल दर्ज करें',
    pleaseEnterEmail: 'कृपया अपना ईमेल पता दर्ज करें',
    emailNotFound: 'ईमेल नहीं मिला',
    sending: 'भेजा जा रहा है...',
    sendResetLink: 'रीसेट लिंक भेजें',
    checkYourEmail: 'अपना ईमेल जांचें',
    resetInstructionsSent: 'हमने आपके ईमेल पते पर पासवर्ड रीसेट निर्देश भेज दिए हैं।',
    tryAnotherEmail: 'दूसरा ईमेल आज़माएं',
    backToSignIn: 'साइन इन पर वापस जाएं',
    fillFields: 'कृपया सभी फ़ील्ड भरें',
    invalidCredentials: 'अमान्य क्रेडेंशियल्स',
    // Background box translations
    loginBonus: 'लॉगिन बोनस',
    welcomeBonus: '$500 स्वागत',
    newUsersOnly: 'नए उपयोगकर्ता केवल',
    secureAccess: 'सुरक्षित पहुंच',
    ssl256: '256-bit SSL',
    bankLevelSecurity: 'बैंक स्तर सुरक्षा',
    aiIntegration: 'AI एकीकरण',
    smartTrading: 'स्मार्ट ट्रेडिंग',
    predictiveAnalytics: 'भविष्यवाणी विश्लेषण',
    globalNetwork: 'वैश्विक नेटवर्क',
    countries150: '150+ देश',
    support247: '24/5 समर्थन',
    // New floating box translations
    highLevelChart: 'उच्च स्तरीय चार्ट',
    realTimeData: 'रीयल-टाइम डेटा',
    advancedAnalytics: 'उन्नत विश्लेषण',
    commission: 'कमीशन',
    earnMore: 'अधिक कमाएं',
    instantPayouts: 'तत्काल भुगतान',
    levelSystem: 'स्तर प्रणाली',
    bronzeLevel: 'कांस्य स्तर',
    silverGoldLevel: 'चांदी और सोना',
    rewards: 'पुरस्कार',
    exclusiveBonus: 'विशेष बोनस',
    vipBenefits: 'VIP लाभ',
    visitWebsite: 'वेबसाइट देखें',
    // Dashboard translations
    dashboard: 'डैशबोर्ड',
    welcomeBack: 'वापसी पर स्वागत है',
    totalRevenue: 'कुल राजस्व',
    totalCommissions: 'कुल कमीशन',
    activeAffiliates: 'सक्रिय सहयोगी',
    conversionRate: 'रूपांतरण दर',
    partnerLink: 'साझेदार लिंक',
    copyLink: 'लिंक कॉपी करें',
    copied: 'कॉपी किया गया!',
    autoUpgradePackage: 'स्वचालित अपग्रेड पैकेज',
    currentPackage: 'वर्तमान पैकेज',
    nextPackage: 'अगला पैकेज',
    progress: 'प्रगति',
    recentActivity: 'हाल की गतिविधि',
    quickActions: 'त्वरित कार्य',
    performanceMetrics: 'प्रदर्शन मेट्रिक्स',
    viewAll: 'सभी देखें',
    // Navigation
    affiliates: 'सहयोगी',
    commissions: 'कमीशन',
    reports: 'रिपोर्ट',
    settings: 'सेटिंग्स',
    logout: 'लॉगआउट',
    // Dynamic Menu Items
    marketing: 'मार्केटिंग',
    rewards: 'पुरस्कार',
    support: 'सहायता',
    notifications: 'अधिसूचनाएं',
    // Common
    search: 'खोजें',
    filter: 'फ़िल्टर',
    export: 'निर्यात',
    save: 'सहेजें',
    cancel: 'रद्द करें',
    edit: 'संपादित करें',
    delete: 'हटाएं',
    view: 'देखें',
    add: 'जोड़ें',
    update: 'अपडेट करें',
    status: 'स्थिति',
    date: 'तारीख',
    amount: 'राशि',
    actions: 'कार्रवाई',
    // More Dashboard translations
    balance: 'बैलेंस',
    totalClients: 'कुल ग्राहक',
    activeClients: 'सक्रिय ग्राहक',
    level: 'स्तर',
    progressToLevel: 'स्तर तक प्रगति',
    partnerLink: 'साझेदार लिंक',
    copyLink: 'लिंक कॉपी करें',
    copied: 'कॉपी किया गया!',
    autoUpgradePackage: 'स्वचालित अपग्रेड पैकेज',
    currentPackage: 'वर्तमान पैकेज',
    nextPackage: 'अगला पैकेज',
    recentActivity: 'हाल की गतिविधि',
    quickActions: 'त्वरित कार्य',
    performanceMetrics: 'प्रदर्शन मेट्रिक्स',
    viewAll: 'सभी देखें',
    // More common translations
    welcome: 'स्वागत',
    back: 'वापस',
    here: 'यहाँ',
    is: 'है',
    with: 'के साथ',
    your: 'आपका',
    business: 'व्यवसाय',
    today: 'आज',
    account: 'खाता',
    overview: 'अवलोकन',
    // More specific translations
    totalProfit: 'कुल लाभ',
    thisMonth: 'इस महीने',
    lifetimeEarnings: 'जीवन भर की कमाई',
    systemManagesLevel: 'सिस्टम आपके स्तर को स्वचालित रूप से प्रबंधित करता है',
    progressToNext: 'अगले तक प्रगति',
    autoUpgradeSystem: 'स्वचालित अपग्रेड सिस्टम',
    current: 'वर्तमान',
    required: 'आवश्यक',
    remaining: 'शेष',
    autoUpgradeWhenTarget: 'लक्ष्य पूरा होने पर स्वचालित अपग्रेड',
    // More translations
    latestTransactions: 'नवीनतम लेन-देन और घटनाएं',
    commonTasks: 'सामान्य कार्य और शॉर्टकट',
    viewClients: 'ग्राहक देखें',
    analytics: 'विश्लेषण',
    support: 'समर्थन',
    thisMonthPerformance: 'इस महीने का प्रदर्शन अवलोकन',
    conversionRate: 'रूपांतरण दर',
    avgCommission: 'औसत कमीशन',
    activeDays: 'सक्रिय दिन',
    responseTime: 'प्रतिक्रिया समय'
  },
  اردو: {
    welcome: 'خوش آمدید',
    signIn: 'اپنے اکاؤنٹ میں سائن ان کریں',
    email: 'ای میل ایڈریس',
    password: 'پاس ورڈ',
    rememberMe: 'مجھے یاد رکھیں',
    forgot: 'بھول گئے؟',
    forgotPassword: 'پاس ورڈ بھول گئے؟',
    signInButton: 'سائن ان کریں',
    signingIn: 'سائن ان ہو رہا ہے...',
    noAccount: 'اکاؤنٹ نہیں ہے؟',
    signUp: 'سائن اپ کریں',
    // Register page translations
    createAccount: 'اکاؤنٹ بنائیں',
    joinAffiliateProgram: 'ہمارے پارٹنر پروگرام میں شامل ہوں',
    firstName: 'پہلا نام',
    lastName: 'آخری نام',
    fullName: 'پورا نام',
    enterFullName: 'اپنا پورا نام درج کریں',
    enterEmail: 'اپنا ای میل درج کریں',
    confirmPassword: 'تصدیق کریں',
    country: 'ملک',
    selectCountry: 'براہ کرم ایک ملک منتخب کریں',
    noCountriesAvailable: 'کوئی ملک دستیاب نہیں',
    loading: 'لوڈ ہو رہا ہے...',
    searchCountries: 'ممالک تلاش کریں...',
    noCountriesFound: 'کوئی ملک نہیں ملا',
    mobileNumber: 'موبائل نمبر',
    stateProvince: 'ریاست',
    selectFromMap: 'نقشے سے منتخب کریں',
    city: 'شہر',
    agreeTo: 'میں رضامند ہوں',
    termsOfService: 'سروس کی شرائط',
    and: 'اور',
    privacyPolicy: 'پرائیویسی پالیسی',
    creatingAccount: 'اکاؤنٹ بنایا جا رہا ہے...',
    alreadyHaveAccount: 'پہلے سے اکاؤنٹ ہے؟',
    selectLocation: 'مقام منتخب کریں',
    searchLocation: 'مقام تلاش کریں...',
    searchCitiesStates: 'شہر، ریاستیں تلاش کریں...',
    noLocationsFoundFor: 'کے لیے کوئی مقام نہیں ملا',
    addAsCustomLocation: 'شامل کریں',
    useAsStateProvince: 'اسے اپنی ریاست کے طور پر استعمال کریں',
    popularLocations: 'مقبول مقامات',
    noPredefinedLocations: 'اس ملک کے لیے کوئی پہلے سے طے شدہ مقامات دستیاب نہیں',
    manuallyTypeStateCity: 'آپ فارم میں اپنی ریاست اور شہر دستی طور پر ٹائپ کر سکتے ہیں',
    atLeast8Characters: 'کم از کم 8 حروف',
    containsLetter: 'حرف شامل ہے',
    containsNumber: 'نمبر شامل ہے',
    containsSpecialCharacter: 'خصوصی حرف شامل ہے',
    // Forgot password translations
    resetPassword: 'پاس ورڈ ری سیٹ کریں',
    enterEmailForReset: 'ری سیٹ ہدایات حاصل کرنے کے لیے اپنا ای میل درج کریں',
    pleaseEnterEmail: 'براہ کرم اپنا ای میل ایڈریس درج کریں',
    emailNotFound: 'ای میل نہیں ملا',
    sending: 'بھیجا جا رہا ہے...',
    sendResetLink: 'ری سیٹ لنک بھیجیں',
    checkYourEmail: 'اپنا ای میل چیک کریں',
    resetInstructionsSent: 'ہم نے آپ کے ای میل ایڈریس پر پاس ورڈ ری سیٹ ہدایات بھیج دی ہیں۔',
    tryAnotherEmail: 'دوسرا ای میل آز مائیں',
    backToSignIn: 'سائن ان پر واپس جائیں',
    fillFields: 'براہ کرم تمام فیلڈز بھریں',
    invalidCredentials: 'غلط کریڈینشلز',
    // Background box translations
    loginBonus: 'لاگ ان بونس',
    welcomeBonus: '$500 خوش آمدید',
    newUsersOnly: 'نئے صارفین صرف',
    secureAccess: 'محفوظ رسائی',
    ssl256: '256-bit SSL',
    bankLevelSecurity: 'بینک لیول سیکیورٹی',
    aiIntegration: 'AI انٹیگریشن',
    smartTrading: 'سمارٹ ٹریڈنگ',
    predictiveAnalytics: 'پیش گوئی تجزیہ',
    globalNetwork: 'عالمی نیٹ ورک',
    countries150: '150+ ممالک',
    support247: '24/5 سپورٹ',
    // New floating box translations
    highLevelChart: 'اعلی سطحی چارٹ',
    realTimeData: 'ریئل ٹائم ڈیٹا',
    advancedAnalytics: 'اعلی درجے کا تجزیہ',
    commission: 'کمیشن',
    earnMore: 'زیادہ کمائیں',
    instantPayouts: 'فوری ادائیگی',
    levelSystem: 'لیول سسٹم',
    bronzeLevel: 'کانسی لیول',
    silverGoldLevel: 'چاندی اور سونا',
    rewards: 'انعامات',
    exclusiveBonus: 'خصوصی بونس',
    vipBenefits: 'VIP فوائد',
    visitWebsite: 'ویب سائٹ دیکھیں',
    // Dashboard translations
    dashboard: 'ڈیش بورڈ',
    welcomeBack: 'خوش آمدید',
    totalRevenue: 'کل آمدنی',
    totalCommissions: 'کل کمیشن',
    activeAffiliates: 'فعال شراکت دار',
    conversionRate: 'تبدیلی کی شرح',
    partnerLink: 'شراکت دار لنک',
    copyLink: 'لنک کاپی کریں',
    copied: 'کاپی ہو گیا!',
    autoUpgradePackage: 'خودکار اپ گریڈ پیکج',
    currentPackage: 'موجودہ پیکج',
    nextPackage: 'اگلا پیکج',
    progress: 'ترقی',
    recentActivity: 'حالیہ سرگرمی',
    quickActions: 'فوری کارروائیاں',
    performanceMetrics: 'کارکردگی کے پیمانے',
    viewAll: 'سب دیکھیں',
    // Navigation
    affiliates: 'شراکت دار',
    commissions: 'کمیشن',
    reports: 'رپورٹس',
    settings: 'ترتیبات',
    logout: 'لاگ آؤٹ',
    // Dynamic Menu Items
    marketing: 'مارکیٹنگ',
    rewards: 'انعامات',
    support: 'سپورٹ',
    notifications: 'نوٹیفیکیشنز',
    // Sub-menu items
    affiliateList: 'شراکت دار کی فہرست',
    affiliateRequests: 'شراکت دار کی درخواستیں',
    commissionHistory: 'کمیشن کی تاریخ',
    commissionSettings: 'کمیشن کی ترتیبات',
    salesReports: 'فروخت کی رپورٹس',
    performanceReports: 'کارکردگی کی رپورٹس',
    analytics: 'تجزیہ',
    campaigns: 'مہمات',
    marketingMaterials: 'مارکیٹنگ کے مواد',
    rewardsProgram: 'انعامات کا پروگرام',
    rewardsHistory: 'انعامات کی تاریخ',
    supportTickets: 'سپورٹ ٹکٹس',
    faq: 'اکثر پوچھے گئے سوالات',
    profile: 'پروفائل',
    security: 'سیکیورٹی',
    preferences: 'ترجیحات',
    // Common
    search: 'تلاش',
    filter: 'فلٹر',
    export: 'برآمد',
    save: 'محفوظ کریں',
    cancel: 'منسوخ کریں',
    edit: 'ترمیم',
    delete: 'حذف کریں',
    view: 'دیکھیں',
    add: 'شامل کریں',
    update: 'اپڈیٹ کریں',
    status: 'حیثیت',
    date: 'تاریخ',
    amount: 'رقم',
    actions: 'کارروائیاں',
    // More Dashboard translations
    balance: 'بیلنس',
    totalClients: 'کل کلائنٹس',
    activeClients: 'فعال کلائنٹس',
    level: 'لیول',
    progressToLevel: 'لیول تک ترقی',
    partnerLink: 'شراکت دار لنک',
    copyLink: 'لنک کاپی کریں',
    copied: 'کاپی ہو گیا!',
    autoUpgradePackage: 'خودکار اپ گریڈ پیکج',
    currentPackage: 'موجودہ پیکج',
    nextPackage: 'اگلا پیکج',
    recentActivity: 'حالیہ سرگرمی',
    quickActions: 'فوری کارروائیاں',
    performanceMetrics: 'کارکردگی کے پیمانے',
    viewAll: 'سب دیکھیں',
    // More common translations
    welcome: 'خوش آمدید',
    back: 'واپس',
    here: 'یہاں',
    is: 'ہے',
    with: 'کے ساتھ',
    your: 'آپ کا',
    business: 'کاروبار',
    today: 'آج',
    account: 'اکاؤنٹ',
    overview: 'جائزہ',
    // More specific translations
    totalProfit: 'کل منافع',
    thisMonth: 'اس مہینے',
    lifetimeEarnings: 'زندگی بھر کی کمائی',
    systemManagesLevel: 'سسٹم آپ کے لیول کو خودکار طریقے سے منظم کرتا ہے',
    progressToNext: 'اگلے تک ترقی',
    autoUpgradeSystem: 'خودکار اپ گریڈ سسٹم',
    current: 'موجودہ',
    required: 'ضروری',
    remaining: 'باقی',
    autoUpgradeWhenTarget: 'ہدف پورا ہونے پر خودکار اپ گریڈ',
    // More translations
    latestTransactions: 'تازہ ترین لین دین اور واقعات',
    commonTasks: 'عام کام اور شارٹ کٹس',
    viewClients: 'کلائنٹس دیکھیں',
    analytics: 'تجزیہ',
    support: 'سپورٹ',
    thisMonthPerformance: 'اس مہینے کی کارکردگی کا جائزہ',
    conversionRate: 'تبدیلی کی شرح',
    avgCommission: 'اوسط کمیشن',
    activeDays: 'فعال دن',
    responseTime: 'جواب کا وقت'
  },
  Español: {
    welcome: 'Bienvenido de vuelta',
    signIn: 'Inicia sesión en tu cuenta',
    email: 'Dirección de correo',
    password: 'Contraseña',
    rememberMe: 'Recuérdame',
    forgot: '¿Olvidaste?',
    forgotPassword: '¿Olvidaste tu contraseña?',
    signInButton: 'Iniciar sesión',
    signingIn: 'Iniciando sesión...',
    noAccount: '¿No tienes cuenta?',
    signUp: 'Registrarse',
    // Register page translations
    createAccount: 'Crear cuenta',
    joinAffiliateProgram: 'Únete a nuestro programa de partners',
    fullName: 'Nombre completo',
    enterFullName: 'Ingresa tu nombre completo',
    enterEmail: 'Ingresa tu email',
    confirmPassword: 'Confirmar',
    country: 'País',
    selectCountry: 'Por favor selecciona un país',
    noCountriesAvailable: 'No hay países disponibles',
    loading: 'Cargando...',
    searchCountries: 'Buscar países...',
    noCountriesFound: 'No se encontraron países',
    mobileNumber: 'Número de móvil',
    stateProvince: 'Estado',
    selectFromMap: 'Seleccionar del mapa',
    city: 'Ciudad',
    agreeTo: 'Acepto los',
    termsOfService: 'Términos de Servicio',
    and: 'y',
    privacyPolicy: 'Política de Privacidad',
    creatingAccount: 'Creando cuenta...',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    selectLocation: 'Seleccionar ubicación',
    searchLocation: 'Buscar una ubicación...',
    searchCitiesStates: 'Buscar ciudades, estados...',
    noLocationsFoundFor: 'No se encontraron ubicaciones para',
    addAsCustomLocation: 'Agregar',
    useAsStateProvince: 'Usar esto como tu estado',
    popularLocations: 'Ubicaciones populares',
    noPredefinedLocations: 'No hay ubicaciones predefinidas disponibles para este país',
    manuallyTypeStateCity: 'Puedes escribir manualmente tu estado y ciudad en el formulario',
    atLeast8Characters: 'Al menos 8 caracteres',
    containsLetter: 'Contiene letra',
    containsNumber: 'Contiene número',
    containsSpecialCharacter: 'Contiene carácter especial',
    // Forgot password translations
    resetPassword: 'Restablecer contraseña',
    enterEmailForReset: 'Ingresa tu email para recibir instrucciones de restablecimiento',
    pleaseEnterEmail: 'Por favor ingresa tu dirección de email',
    emailNotFound: 'Email no encontrado',
    sending: 'Enviando...',
    sendResetLink: 'Enviar enlace de restablecimiento',
    checkYourEmail: 'Revisa tu email',
    resetInstructionsSent: 'Hemos enviado instrucciones de restablecimiento de contraseña a tu dirección de email.',
    tryAnotherEmail: 'Probar otro email',
    backToSignIn: 'Volver a iniciar sesión',
    fillFields: 'Por favor completa todos los campos',
    invalidCredentials: 'Credenciales inválidas',
    // Background box translations
    loginBonus: 'BONO DE INICIO',
    welcomeBonus: '$500 Bienvenida',
    newUsersOnly: 'Solo nuevos usuarios',
    secureAccess: 'ACCESO SEGURO',
    ssl256: '256-bit SSL',
    bankLevelSecurity: 'Seguridad de nivel bancario',
    aiIntegration: 'INTEGRACIÓN IA',
    smartTrading: 'Trading Inteligente',
    predictiveAnalytics: 'Análisis Predictivo',
    globalNetwork: 'RED GLOBAL',
    countries150: '150+ Países',
    support247: 'Soporte 24/5',
    // New floating box translations
    highLevelChart: 'GRÁFICO DE ALTO NIVEL',
    realTimeData: 'Datos en Tiempo Real',
    advancedAnalytics: 'Análisis Avanzado',
    commission: 'COMISIÓN',
    earnMore: 'Gana Más',
    instantPayouts: 'Pagos Instantáneos',
    stockMarket: 'MERCADO DE VALORES',
    globalMarkets: 'Mercados Globales',
    trading24x7: 'Trading 24/7',
    rewards: 'RECOMPENSAS',
    exclusiveBonus: 'Bono Exclusivo',
    vipBenefits: 'Beneficios VIP',
    visitWebsite: 'Visitar Sitio Web',
    // Dashboard translations
    dashboard: 'Panel de Control',
    welcomeBack: 'Bienvenido de vuelta',
    totalRevenue: 'Ingresos Totales',
    totalCommissions: 'Comisiones Totales',
    activeAffiliates: 'Partners Activos',
    conversionRate: 'Tasa de Conversión',
    partnerLink: 'Enlace de Socio',
    copyLink: 'Copiar Enlace',
    copied: '¡Copiado!',
    autoUpgradePackage: 'Paquete de Actualización Automática',
    currentPackage: 'Paquete Actual',
    nextPackage: 'Siguiente Paquete',
    progress: 'Progreso',
    recentActivity: 'Actividad Reciente',
    quickActions: 'Acciones Rápidas',
    performanceMetrics: 'Métricas de Rendimiento',
    viewAll: 'Ver Todo',
    // Navigation
    affiliates: 'Partners',
    commissions: 'Comisiones',
    reports: 'Reportes',
    settings: 'Configuración',
    logout: 'Cerrar Sesión',
    // Common
    search: 'Buscar',
    filter: 'Filtrar',
    export: 'Exportar',
    save: 'Guardar',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Eliminar',
    view: 'Ver',
    add: 'Agregar',
    update: 'Actualizar',
    status: 'Estado',
    date: 'Fecha',
    amount: 'Cantidad',
    actions: 'Acciones',
    // More Dashboard translations
    balance: 'Saldo',
    totalClients: 'Total de Clientes',
    activeClients: 'Clientes Activos',
    level: 'Nivel',
    progressToLevel: 'Progreso al Nivel',
    partnerLink: 'Enlace de Socio',
    copyLink: 'Copiar Enlace',
    copied: '¡Copiado!',
    autoUpgradePackage: 'Paquete de Actualización Automática',
    currentPackage: 'Paquete Actual',
    nextPackage: 'Siguiente Paquete',
    recentActivity: 'Actividad Reciente',
    quickActions: 'Acciones Rápidas',
    performanceMetrics: 'Métricas de Rendimiento',
    viewAll: 'Ver Todo',
    // More common translations
    welcome: 'Bienvenido',
    back: 'Atrás',
    here: 'Aquí',
    is: 'es',
    with: 'con',
    your: 'Tu',
    business: 'Negocio',
    today: 'Hoy',
    account: 'Cuenta',
    overview: 'Resumen',
    // More specific translations
    totalProfit: 'Beneficio Total',
    thisMonth: 'este mes',
    lifetimeEarnings: 'Ganancias de por vida',
    systemManagesLevel: 'El sistema gestiona tu nivel automáticamente',
    progressToNext: 'Progreso al Siguiente',
    autoUpgradeSystem: 'Sistema de actualización automática',
    current: 'Actual',
    required: 'Requerido',
    remaining: 'Restante',
    autoUpgradeWhenTarget: 'Actualización automática cuando se alcance el objetivo',
    // More translations
    latestTransactions: 'Últimas transacciones y eventos',
    commonTasks: 'Tareas comunes y atajos',
    viewClients: 'Ver Clientes',
    analytics: 'Análisis',
    support: 'Soporte',
    thisMonthPerformance: 'Resumen de rendimiento de este mes',
    conversionRate: 'Tasa de Conversión',
    avgCommission: 'Comisión Promedio',
    activeDays: 'Días Activos',
    responseTime: 'Tiempo de Respuesta'
  },
  Français: {
    welcome: 'Bon retour',
    signIn: 'Connectez-vous à votre compte',
    email: 'Adresse e-mail',
    password: 'Mot de passe',
    rememberMe: 'Se souvenir de moi',
    forgot: 'Oublié?',
    forgotPassword: 'Mot de passe oublié?',
    signInButton: 'Se connecter',
    signingIn: 'Connexion en cours...',
    noAccount: "Vous n'avez pas de compte?",
    signUp: "S'inscrire",
    // Register page translations
    createAccount: 'Créer un compte',
    joinAffiliateProgram: 'Rejoignez notre programme partenaire',
    fullName: 'Nom complet',
    enterFullName: 'Entrez votre nom complet',
    enterEmail: 'Entrez votre email',
    confirmPassword: 'Confirmer',
    country: 'Pays',
    selectCountry: 'Veuillez sélectionner un pays',
    noCountriesAvailable: 'Aucun pays disponible',
    loading: 'Chargement...',
    searchCountries: 'Rechercher des pays...',
    noCountriesFound: 'Aucun pays trouvé',
    mobileNumber: 'Numéro de mobile',
    stateProvince: 'État',
    selectFromMap: 'Sélectionner sur la carte',
    city: 'Ville',
    agreeTo: 'J\'accepte les',
    termsOfService: 'Conditions de Service',
    and: 'et',
    privacyPolicy: 'Politique de Confidentialité',
    creatingAccount: 'Création du compte...',
    alreadyHaveAccount: 'Vous avez déjà un compte?',
    selectLocation: 'Sélectionner un emplacement',
    searchLocation: 'Rechercher un emplacement...',
    searchCitiesStates: 'Rechercher des villes, états...',
    noLocationsFoundFor: 'Aucun emplacement trouvé pour',
    addAsCustomLocation: 'Ajouter',
    useAsStateProvince: 'Utiliser ceci comme votre état',
    popularLocations: 'Emplacements populaires',
    noPredefinedLocations: 'Aucun emplacement prédéfini disponible pour ce pays',
    manuallyTypeStateCity: 'Vous pouvez saisir manuellement votre état et ville dans le formulaire',
    atLeast8Characters: 'Au moins 8 caractères',
    containsLetter: 'Contient une lettre',
    containsNumber: 'Contient un chiffre',
    containsSpecialCharacter: 'Contient un caractère spécial',
    // Forgot password translations
    resetPassword: 'Réinitialiser le mot de passe',
    enterEmailForReset: 'Entrez votre email pour recevoir les instructions de réinitialisation',
    pleaseEnterEmail: 'Veuillez entrer votre adresse email',
    emailNotFound: 'Email non trouvé',
    sending: 'Envoi en cours...',
    sendResetLink: 'Envoyer le lien de réinitialisation',
    checkYourEmail: 'Vérifiez votre email',
    resetInstructionsSent: 'Nous avons envoyé les instructions de réinitialisation de mot de passe à votre adresse email.',
    tryAnotherEmail: 'Essayer un autre email',
    backToSignIn: 'Retour à la connexion',
    fillFields: 'Veuillez remplir tous les champs',
    invalidCredentials: 'Identifiants invalides',
    // Background box translations
    loginBonus: 'BONUS DE CONNEXION',
    welcomeBonus: '$500 Bienvenue',
    newUsersOnly: 'Nouveaux utilisateurs uniquement',
    secureAccess: 'ACCÈS SÉCURISÉ',
    ssl256: '256-bit SSL',
    bankLevelSecurity: 'Sécurité de niveau bancaire',
    aiIntegration: 'INTÉGRATION IA',
    smartTrading: 'Trading Intelligent',
    predictiveAnalytics: 'Analyse Prédictive',
    globalNetwork: 'RÉSEAU MONDIAL',
    countries150: '150+ Pays',
    support247: 'Support 24/5',
    // New floating box translations
    highLevelChart: 'GRAPHIQUE HAUT NIVEAU',
    realTimeData: 'Données en Temps Réel',
    advancedAnalytics: 'Analyse Avancée',
    commission: 'COMMISSION',
    earnMore: 'Gagnez Plus',
    instantPayouts: 'Paiements Instantanés',
    stockMarket: 'MARCHÉ BOURSIER',
    globalMarkets: 'Marchés Mondiaux',
    trading24x7: 'Trading 24/7',
    rewards: 'RÉCOMPENSES',
    exclusiveBonus: 'Bonus Exclusif',
    vipBenefits: 'Avantages VIP',
    visitWebsite: 'Visiter le Site Web',
    // Dashboard translations
    dashboard: 'Tableau de Bord',
    welcomeBack: 'Bon retour',
    totalRevenue: 'Revenus Totaux',
    totalCommissions: 'Commissions Totales',
    activeAffiliates: 'Partners Actifs',
    conversionRate: 'Taux de Conversion',
    partnerLink: 'Lien Partenaire',
    copyLink: 'Copier le Lien',
    copied: 'Copié !',
    autoUpgradePackage: 'Package de Mise à Niveau Automatique',
    currentPackage: 'Package Actuel',
    nextPackage: 'Package Suivant',
    progress: 'Progrès',
    recentActivity: 'Activité Récente',
    quickActions: 'Actions Rapides',
    performanceMetrics: 'Métriques de Performance',
    viewAll: 'Voir Tout',
    // Navigation
    affiliates: 'Partners',
    commissions: 'Commissions',
    reports: 'Rapports',
    settings: 'Paramètres',
    logout: 'Déconnexion',
    // Common
    search: 'Rechercher',
    filter: 'Filtrer',
    export: 'Exporter',
    save: 'Enregistrer',
    cancel: 'Annuler',
    edit: 'Modifier',
    delete: 'Supprimer',
    view: 'Voir',
    add: 'Ajouter',
    update: 'Mettre à Jour',
    status: 'Statut',
    date: 'Date',
    amount: 'Montant',
    actions: 'Actions',
    // More Dashboard translations
    balance: 'Solde',
    totalClients: 'Total des Clients',
    activeClients: 'Clients Actifs',
    level: 'Niveau',
    progressToLevel: 'Progrès vers le Niveau',
    partnerLink: 'Lien Partenaire',
    copyLink: 'Copier le Lien',
    copied: 'Copié !',
    autoUpgradePackage: 'Package de Mise à Niveau Automatique',
    currentPackage: 'Package Actuel',
    nextPackage: 'Package Suivant',
    recentActivity: 'Activité Récente',
    quickActions: 'Actions Rapides',
    performanceMetrics: 'Métriques de Performance',
    viewAll: 'Voir Tout',
    // More common translations
    welcome: 'Bienvenue',
    back: 'Retour',
    here: 'Ici',
    is: 'est',
    with: 'avec',
    your: 'Votre',
    business: 'Entreprise',
    today: 'Aujourd\'hui',
    account: 'Compte',
    overview: 'Aperçu',
    // More specific translations
    totalProfit: 'Bénéfice Total',
    thisMonth: 'ce mois',
    lifetimeEarnings: 'Gains à vie',
    systemManagesLevel: 'Le système gère votre niveau automatiquement',
    progressToNext: 'Progrès vers le Suivant',
    autoUpgradeSystem: 'Système de mise à niveau automatique',
    current: 'Actuel',
    required: 'Requis',
    remaining: 'Restant',
    autoUpgradeWhenTarget: 'Mise à niveau automatique quand l\'objectif est atteint',
    // More translations
    latestTransactions: 'Dernières transactions et événements',
    commonTasks: 'Tâches communes et raccourcis',
    viewClients: 'Voir les Clients',
    analytics: 'Analyses',
    support: 'Support',
    thisMonthPerformance: 'Aperçu des performances de ce mois',
    conversionRate: 'Taux de Conversion',
    avgCommission: 'Commission Moyenne',
    activeDays: 'Jours Actifs',
    responseTime: 'Temps de Réponse'
  }
};
